export default {
  handleDocumentContainer: {
    title: 'Joindre un devis',
    text: 'Concernant vos dommages immobilers, présentez-nous un devis d’un artisan de votre choix. Celui-ci sera revu par notre cellule technique qui le validera ou prendra contact avec vous si besoin.',
    billmaSolution: {
      title: 'Dommages immobiliers',
      solution: 'Solution : Choisir mon propre artisan',
      text1: 'Joignez à présent le devis de votre artisan pour analyse.',
      text2: 'En nous transmettant vos documents, vous acceptez que ces derniers soient analysés manuellement ou bien par un algorithme.',
      text3: 'Devis :',
      uploadBtn: 'Ajouter un document'
    },
    actions: {
      primary: 'Continuer',
      tertiary: 'Choisir une autre solution'
    },
    documentUploadStep: {
      actions: {
        primary: 'Joindre le document'
      }
    },
    icrModal: {
      title: 'Chargement du devis en cours',
      title2: "Votre document est en cours d'analyse",
      text1: 'Le fichier a bien été chargé. Veuillez patienter.',
      text2: 'Votre fichier est en cours de traitement.',
      text3:
        'Veuillez patienter, cette opération peut prendre quelques minutes'
    }
  }
}
